import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { getStartDateForSchoolYear } from 'Src/helpers/calendar/calendar';
import { getDefaultReportAgesForMultiSelect, getReportDefaultGendersForMultiSelect } from 'Src/helpers/multiselect/multiselect';
import { UnionSchoolReportForm } from '../UnionSchoolReportForm';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; }
export function UnionSchoolTargetParticipationStatisticsReportForm({ onCloseClick, onSubmit }: Props) {
  const now = new Date();
  return <UnionSchoolReportForm
    initialValues={{ dateFrom: getStartDateForSchoolYear(now), dateTo: now, ageGroups: getDefaultReportAgesForMultiSelect(), genders: getReportDefaultGendersForMultiSelect(), isPrintEligible: true, isPrintPercent: true, isPrintPP: true, isPrintSEN: true, isPrintFSM: true, isSelectAllAges: true }}
    reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_SCHOOL_TARGET_PARTICIPATION_STATISTICS}
    description="Compare target participation statistics across union schools for the selected period and audience."
    toggles={[
      { field: 'isPrintEligible', label: 'Eligible students', hint: 'Show the number of students eligible to participate.' },
      { field: 'isPrintPercent', label: 'Percentages', hint: 'Show percentage values alongside totals.' },
      { field: 'isPrintPP', label: 'Pupil Premium breakdown', hint: 'Split statistics by Pupil Premium status.' },
      { field: 'isPrintSEN', label: 'SEN breakdown', hint: 'Split statistics by special educational needs status.' },
      { field: 'isPrintFSM', label: 'Free School Meals breakdown', hint: 'Split statistics by Free School Meals status.' }
    ]}
    onCloseClick={onCloseClick} onSubmit={onSubmit}
  />;
}
